import React, { useContext, useEffect, useState } from "react";
import { ErrorContainer, StyledLinkButton, StyledTitleBold, StyledTwoBoxWrapper, SuccessContainer } from "../style/global.style";
import { CancelLeft, CancelLeftInner, CancelRight, StyledCancelPlan, StyledCardHorizontalContainer } from "./plans.style";

import Recommendation from "../commons/recommendation/Recommendation.component";
import { cancelPlan as _cancelPlan } from "../../services/globalService";
import LinkButton from "../linkButton/LinkButton.component";
import { useHistory } from "react-router-dom";
import SmallLoader from "../../components/utils/SmallLoader";
import StateContext from "../../context/StateContext";

const AreYouSure = (props) => {
	const [plan, setPlan] = useState(props.location.state);
	const [error, setError] = useState(null);
	const [success, setSuccess] = useState(null);
	const history = useHistory();
	const [showSpinner, setShowSpinner] = useState(false);
	const { plans, dispatch, ACTIONS } = useContext(StateContext);

	useEffect(() => {
		setPlan(props.location.state);
	}, [props.location.state]);

	const cancelPlan = async (e) => {
		e.preventDefault();
		try {
			if (plan?.plan_id) {
				setShowSpinner(true);
				const res = await _cancelPlan(plan.plan_id);
				if (!res) setError("There was a problem canceling your plan, please contact us at stores@fixel.ai or try again later");
				localStorage.setItem("planCancelled", plan.plan_id);
				setSuccess("Plan canceled. Redirecting...");
				setTimeout(() => {
					const newPlans = plans.map((p) => (p.plan_id === plan.plan_id ? res.data : p));
					dispatch({ type: ACTIONS.SET_PLANS, payload: newPlans });
					history.push("/dashboard");
				}, 3000);
			} else {
				throw new Error("");
			}
		} catch (err) {
			console.error(err);
			setError("There was a problem canceling your plan, please contact us at stores@fixel.ai or try again later");
		} finally {
			setShowSpinner(false);
		}
	};

	return (
		<StyledCancelPlan>
			<StyledTwoBoxWrapper className={"mt-1"}>
				<CancelLeft>
					<CancelLeftInner>
						{error && <ErrorContainer className={"shake"}>{error}</ErrorContainer>}
						{success && <SuccessContainer>{success}</SuccessContainer>}
						<StyledTitleBold>Are you sure?</StyledTitleBold>
						Cancelling your Fixel Pro plan will{" "}
						<strong>
							disable your <br /> Fixel installation.
						</strong>
						<br />
						<br />
						The existing audiences in your ad platforms will <br /> persist and will still be available for your <br /> campaign.
						<br />
						<br />
						However, since they won't be updated, their <br /> performance is expected to deteriorate over
						<br /> time.
						<StyledCardHorizontalContainer>
							<StyledLinkButton onClick={() => history.push("/dashboard")}>continue tracking</StyledLinkButton>
							<LinkButton alert={true} onClick={(event) => cancelPlan(event)} disabled={showSpinner}>
								{showSpinner ? <SmallLoader inline={true} /> : "cancel anyway"}
							</LinkButton>
						</StyledCardHorizontalContainer>
					</CancelLeftInner>
				</CancelLeft>
				<CancelRight>
					<Recommendation />
				</CancelRight>
			</StyledTwoBoxWrapper>
		</StyledCancelPlan>
	);
};
export default React.memo(AreYouSure);
